import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { CustomerSettingsModel, T4TurboOrderService, ComponentBase, OrderCustomerModel, T4ListItem } from 't4core';
import { NewOrderDialog } from '../../dialogs/neworder/neworder';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { create } from 'domain';

@Component({
  selector: 't4order-CustomerSettings',
  templateUrl: './CustomerSettings.html',
  styleUrls: ['./CustomerSettings.css']
})
export class CustomerSettings extends ComponentBase {

  public settings: CustomerSettingsModel = new CustomerSettingsModel();
  @Input() public customerId: number;

  public groups: T4ListItem[] = [];
  public implicitGroup: string = "";
  public servicePartners: OrderCustomerModel[];

  public selectedGroup: string = "";

  form: FormGroup;
  payoutOptions = ['Other','BG', 'IBAN', 'SWIFT',];
  constructor(el: ElementRef, private orderSvc: T4TurboOrderService, private fb: FormBuilder) {
        super();

    }

  ngOnChanges(changes: SimpleChanges) {
      this.loadSettings(this.customerId);
  }


  ngOnInit() {

    this.form = this.fb.group({
      payouts: this.fb.array([]) 
    });
  }

  async loadSettings(customerId: number) {
    this.settings = await this.orderSvc.GetCustomerSettings(customerId);
    this.groups = await this.orderSvc.GetT4Groups();

    this.servicePartners = await this.orderSvc.FilterCustomers("", 50, true);
    if (this.settings.Payment.PayoutInfo) {
      this.mapStringToRows(this.settings.Payment.PayoutInfo);
    }

    this.implicitGroup = this.groups.find(x => x.Id == this.settings.T4.ImplicitGroupId.toString())?.Name;

    this.selectedGroup = this.settings?.T4?.LocationGroupId != null ? this.settings.T4.LocationGroupId.toString() : "";
  }

  async saveSettings() {
    if (this.settings.T4.LocationGroupId !== parseInt(this.selectedGroup))
      this.settings.T4.LocationGroupId = parseInt(this.selectedGroup, 10);
      
    this.settings.Payment.PayoutInfo = this.mapPayoutString();

    await this.orderSvc.SaveCustomerSettings(this.customerId, this.settings)
    this.UI.snackBar("Saved!");
  }

  async selectPartner() {
    let dialog2 = this.Dialog.open(NewOrderDialog, { data: { hidePricelist: true, requireExisting: true } });
    var result = await dialog2.afterClosed().toPromise();

      if (result) {
        if (result.selectedCustomer) {
         let customer: OrderCustomerModel = result.selectedCustomer;

          this.settings.Service.RepairPartnerId = customer.Id;
          this.UI.snackBar(customer.Name + " selected as new service partner");
        }
    }
  }
  async selectLocalPartner() {
    let dialog2 = this.Dialog.open(NewOrderDialog, { data: { hidePricelist: true, requireExisting: true, requireServiceLocation: true } });
    var result = await dialog2.afterClosed().toPromise();

    if (result) {
      if (result.selectedCustomer) {
        let customer: OrderCustomerModel = result.selectedCustomer;

        this.settings.Service.ServicePartnerId = customer.Id;
        this.onServicePartnerChanged(customer.Id);
        this.UI.snackBar(customer.Name + " selected as new service partner");
      }
    }
  }

  public onServicePartnerChanged(servicePartnerId: number) {
    if (!this.settings?.Service) return;

    if (!this.settings.Service.UsedPartner) {
      this.settings.Service.UsedPartner = servicePartnerId;
    }
  }


  // === Paythough Settings ===
  get payouts() {
    if (this.form.get('payouts'))
      return this.form.get('payouts') as FormArray;
    else return null;
  }

  createPayoutGroup(type: string = '', payoutInfo: string = '') {
 
    if (!type) {
      const selectedTypes = this.getSelectedTypes().filter(type => type !== 'Other');
      type = this.payoutOptions.find(option => option === 'Other' || !selectedTypes.includes(option)) || '';
    }

    return this.fb.group({
      type: [type, Validators.required], 
      payoutInfo: [payoutInfo, Validators.required]  
    });
  }


  addInput() {
    this.payouts.push(this.createPayoutGroup());
  }

  getSelectedTypes() {
    return this.payouts.controls.map(control => control.get('type')?.value);
  }

  getAvailableOptions(selectedType?: string): string[] {
    const selectedTypes = this.getSelectedTypes().filter(type => type !== 'Other');

    return this.payoutOptions.filter(option => option === 'Other' || selectedTypes.indexOf(option) === -1 || option === selectedType);
  }

  removeInput(index: number) {
    this.payouts.removeAt(index);
  }

  isSaveDisabled(): boolean {
    return this.payouts.controls.some(control => {
      const type = control.get('type')?.value;
      const payoutInfo = control.get('payoutInfo')?.value;
      return type && !payoutInfo; 
    });
  }


  mapPayoutString() {
    const payouts = this.payouts.value; 

    /// Gets all expect the other Type.
    const nonOtherPayouts = payouts
      .filter((payout: any) => payout.type !== 'Other')
      .map((payout: any) => `${payout.type}: ${payout.payoutInfo}`);

    // Get all the Other type.
    const otherPayouts = payouts
      .filter((payout: any) => payout.type === 'Other')
      .map((payout: any) => payout.payoutInfo);

    // Make sure that the other type / input is at the end.
    const resultString = [...nonOtherPayouts, ...otherPayouts].join(', ');

    return resultString;
  }

  mapStringToRows(dataString: string) {
  
    const dataArray = dataString.split(', ');

    this.payouts.clear();

    dataArray.forEach(item => {
      // Split based on ": " to separate type and payoutInfo
      const [type, payoutInfo] = item.includes(': ') ? item.split(': ') : ['Other', item];
      this.payouts.push(this.createPayoutGroup(type.toUpperCase(), payoutInfo));
    });
    console.log(this.payouts);
  }


}
